var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBrands1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5857 28.9344C57.5857 13.45 45.04 0.904297 29.5556 0.904297C14.0712 0.904297 1.52548 13.45 1.52548 28.9344C1.52548 42.9246 11.7757 54.5209 25.1759 56.6254V37.0371H18.0553V28.9344H25.1759V22.7587C25.1759 15.7343 29.3578 11.8541 35.7629 11.8541C38.8304 11.8541 42.038 12.4012 42.038 12.4012V19.2957H38.5026C35.0215 19.2957 33.9353 21.4567 33.9353 23.6731V28.9344H41.7091L40.4659 37.0371H33.9353V56.6254C47.3355 54.5209 57.5857 42.9246 57.5857 28.9344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBrands1);
export default __webpack_public_path__ + "static/media/facebook-brands 1.68dcd96df9fb7a4ef25249e7b06f231e.svg";
export { ForwardRef as ReactComponent };